/**
 * Shared display formatter for calendar dates. Single source of truth so the
 * various list/detail tables don't each re-implement "format a date, avoid the
 * UTC day-slip" slightly differently.
 */

/**
 * Format a date value as MM/DD/YYYY for display.
 *
 * Accepts a date-only string (`YYYY-MM-DD`) or a full ISO timestamp
 * (`YYYY-MM-DDTHH:MM:SSZ`) — only the leading calendar date is read. No `Date`
 * object is constructed, so the value never slips across timezones and an
 * out-of-range day is shown verbatim rather than silently rolled over (e.g.
 * `2026-02-31` → `02/31/2026`, not `03/03/2026`). Returns `fallback` (default
 * `—`) for null/empty input or anything without a leading ISO date.
 */
export function formatDateMMDDYYYY(value: string | null | undefined, fallback = '—'): string {
  if (!value) return fallback;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return fallback;
  const [, year, month, day] = match;
  return `${month}/${day}/${year}`;
}
